import { render, staticRenderFns } from "./DialogAddTagsType.vue?vue&type=template&id=901a4894&scoped=true&"
import script from "./DialogAddTagsType.vue?vue&type=script&lang=js&"
export * from "./DialogAddTagsType.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddTagsType.vue?vue&type=style&index=0&id=901a4894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901a4894",
  null
  
)

export default component.exports